import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';

export const Wrapper = styled.div`
  label {
    padding-bottom: ${sizes.xxSmall};
    letter-spacing: 0.1rem;
    white-space: normal;
    text-transform: none;
  }

  .disabled label {
    color: ${colors.gray4};
  }

  &[aria-disabled="true"] {
    cursor: not-allowed;

    svg {
      path {
        fill: ${colors.gray3};
      }
    }
  }

  .css-gge4d1-control {
    background-color: ${colors.gray2};
  }

  .css-1rn3h3t {
    display: none;
  }

  #dropdown-multiselect > :nth-of-type(4) {
    z-index: 2;
  }

  [class*="-option"] {
    white-space: normal;
    word-wrap: break-word;

    > div:first-of-type {
      flex-shrink: 0;
    }
  }
`;
